import Slider from './slider.es6';

export default class Top {
    constructor() {
        this.Slider = new Slider();
        // this.init();
    }

    init() {}
}
